import { render, staticRenderFns } from "./arrivalRegistration.vue?vue&type=template&id=1bc4b7f4&"
import script from "./arrivalRegistration.vue?vue&type=script&lang=js&"
export * from "./arrivalRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports